/* This file is used via soft links in several aws lambdas.
 * Keep this file and its dependencies in common JS style.
 * When introducing new dependencies to this file, soft-link them to aws lambdas as well.
 */

export const ALERT_TEMPLATE_ENUM = {
  PRICE_ALERT: "priceAlert",
  HACK_SCAN_ALERT: "hackScanAlert",
  WHITELISTED_CALLERS: "whitelistedCallers",
  BLACKLISTED_CALLERS: "blacklistedCallers",
  SUCCEEDED_TRANSACTION: "succeededTransaction",
  FAILED_TRANSACTION: "failedTransaction",
  TRANSACTION_VALUE: "transactionValue",
  EVENT_EMITTED: "eventEmitted",
  EVENT_PARAMETER: "eventParameter",
  ERC20_TOKEN_TRANSFER: "erc20TokenTransfer",
  TOKEN_BUY_OR_SELL: "tokenBuyOrSell",
  TOKEN_VOLUME: "tokenVolume",
  HACKER_ADDRESS: "hackerAddress",
  NFT_ALERT: "nftAlert",
  NFT_COLLECTION_ALERT: "nftCollectionAlert",
  HACK_EVENT_ALERT: "hackEventAlert",
  FLASHLOAN_ALERT: "flashloanAlert",
  PRICE_SLIPPAGE_ALERT: "priceSlippageAlert",
};

export const ALERT_GROUPS_ENUM = {
  SECURITY: "security",
  TRANSACTIONS: "transactions",
  EVENTS: "events",
  VALUE_CHANGE: "value-change",
  HACKER: "hacker",
  NFT_ALERT: "nftAlert",
  NFT_COLLECTION_ALERT: "nftCollectionAlert",
  HACK_EVENT: "hackEvent",
  FLASHLOAN: "flashloanAlert",
  PRICE_SLIPPAGE: "priceSlippageAlert",
};

export const PRICE_ALERT_TEMPLATE = {
  group: ALERT_GROUPS_ENUM.VALUE_CHANGE,
  id: ALERT_TEMPLATE_ENUM.PRICE_ALERT,
  name: "Price Alert",
  description: "Get notified when a token goes above or below a price target.",
  whitelist: [
    "coinGeckoLink",
    "coinMarketCapLink",
    "priceUpperBound",
    "priceLowerBound",
    "tokenTicker",
  ],
};

export const HACK_SCAN_ALERT_TEMPLATE = {
  group: ALERT_GROUPS_ENUM.VALUE_CHANGE,
  id: ALERT_TEMPLATE_ENUM.HACK_SCAN_ALERT,
  name: "Hack Scan Alert",
  description: "Get notified when the Hack Scan score of a project breaks assertion.",
  whitelist: [
    "scoreUpperBoundEnabled",
    "scoreUpperBound",
    "scoreLowerBoundEnabled",
    "scoreLowerBound",
  ],
};

export const HACK_NFT_ALERT_TEMPLATE = {
  group: ALERT_GROUPS_ENUM.NFT_ALERT,
  id: ALERT_TEMPLATE_ENUM.NFT_ALERT,
  name: "NFT Alert",
  description: "Get notified when the nft score breaks assertion.",
  whitelist: [
    "scoreUpperBoundEnabled",
    "scoreUpperBound",
    "scoreLowerBoundEnabled",
    "scoreLowerBound",
  ],
};

export const HACK_EVENT_ALERT_TEMPLATE = {
  group: ALERT_GROUPS_ENUM.HACK_EVENT,
  id: ALERT_TEMPLATE_ENUM.HACK_EVENT_ALERT,
  name: "Hack Event Alert",
  description: "Get notified when hack events happen",
  whitelist: [],
};

export const HACK_NFT_COLLECTION_ALERT_TEMPLATE = {
  group: ALERT_GROUPS_ENUM.NFT_COLLECTION_ALERT,
  id: ALERT_TEMPLATE_ENUM.NFT_COLLECTION_ALERT,
  name: "NFT Collection Alert",
  description: "Get notified when the nft event happen",
};
export const FLASHLOAN_ALERT_TEMPLATE = {
  group: ALERT_GROUPS_ENUM.FLASHLOAN,
  id: ALERT_TEMPLATE_ENUM.FLASHLOAN_ALERT,
  name: "Flashloan Alert",
  description: "Get notified when flashloan alerts happen",
  whitelist: [],
};

export const PRICE_SLIPPAGE_ALERT_TEMPLATE = {
  group: ALERT_GROUPS_ENUM.PRICE_SLIPPAGE,
  id: ALERT_TEMPLATE_ENUM.PRICE_SLIPPAGE_ALERT,
  name: "Price Slippage Alert",
  description: "Get notified when price slippage alerts happen",
  whitelist: [],
};

//for use in alertSubscriptionWorker
export const ALERT_SUBSCRIPTION_EVENTS = [
  HACK_EVENT_ALERT_TEMPLATE.id,
  FLASHLOAN_ALERT_TEMPLATE.id,
  PRICE_SLIPPAGE_ALERT_TEMPLATE.id,
  HACK_NFT_COLLECTION_ALERT_TEMPLATE.id,
];

new Map([
  [ALERT_TEMPLATE_ENUM.PRICE_ALERT, PRICE_ALERT_TEMPLATE],
  [ALERT_TEMPLATE_ENUM.HACK_SCAN_ALERT, HACK_SCAN_ALERT_TEMPLATE],
  [ALERT_TEMPLATE_ENUM.NFT_ALERT, HACK_NFT_ALERT_TEMPLATE],
  [ALERT_TEMPLATE_ENUM.HACK_EVENT_ALERT, HACK_EVENT_ALERT_TEMPLATE],
  [ALERT_TEMPLATE_ENUM.NFT_COLLECTION_ALERT, HACK_NFT_COLLECTION_ALERT_TEMPLATE],
  [ALERT_TEMPLATE_ENUM.FLASHLOAN_ALERT, FLASHLOAN_ALERT_TEMPLATE],
  [ALERT_TEMPLATE_ENUM.PRICE_SLIPPAGE_ALERT, PRICE_SLIPPAGE_ALERT_TEMPLATE],
]);

// 75 years later
